// angular 2
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/http';
import '@angular/router';
// rxJS
import 'rxjs';
// lodash
import 'lodash';
// other vendors for example jQuery, Lodash or Bootstrap
// you can import js, ts, css, sass, ...
import 'jquery/dist/jquery.min';
import 'moment/moment';
import 'fullcalendar/dist/fullcalendar.min';
import 'primeng/primeng';



// WEBPACK FOOTER //
// ./src/vendor.ts